import { distinctUntilChanged } from 'rxjs';
import { Web3Service } from './services/web3.service';
import { WhiteLabelService } from './services/whitelabel.service';
import { UserService } from './services/user.service';

export function checkWhiteLabel(whiteLabelService: WhiteLabelService) {
  return () => {
    return new Promise(async (resolve) => {
      if (whiteLabelService.isWhiteLabel) {
        resolve(true);
      } else {
        whiteLabelService.whiteLabelData.pipe(distinctUntilChanged()).subscribe((data) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        });
      }
    });
  };
}
export function checkUserBalance(web3Service: Web3Service) {
  {
    return () => {
      return new Promise(async (resolve) => {
        const wallet = localStorage.getItem('currentWallet');
        if (wallet) {
          // await web3Service.hasRequiredTokens(wallet,1)
        }
        resolve(true);
      });
    };
  }
}

export function initializeUserData(userService: UserService) {
  return () => {
    return new Promise(async (resolve) => {
      const isAuthenticated = !!localStorage.getItem('accessToken');
      if (isAuthenticated) {
        try {
          await Promise.all([
            userService.getMe(),
            userService.getWallets()
          ]);
        } catch (error) {
          console.error('[AppInitializer] Error fetching user data', error);
        }
      }
      resolve(true);
    });
  };
}
